import React from "react";
import styles from "./b2b-page.module.scss";
import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { PageSectionLayout } from "@/elements-react/page-section-layout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { TargetAudience } from "@/elements-react/target-audience";
import { FeatureGrid } from "@/elements-react/feature-grid";
import { ComparisonSection } from "@/elements-react/comparison-section";
import { BottomCta } from "@/elements-react/bottom-cta";
import { WorkFaster } from "@/elements-react/work-faster";

export const B2bPageDesktop: React.FC = withCatalogLayout(() => {

    return (
        <div className={styles.container}>
            <PageSectionLayout type={LayoutStyleTypes.TYPE_LG}>
                <TargetAudience />
                <WorkFaster />
                <FeatureGrid />
                <ComparisonSection />
            </PageSectionLayout>
            <BottomCta />
        </div>
    );
});
